import React from "react";
import SignupCard from "../components/Signup/SignupCard";

const Signup = () => {
  return <SignupCard />;
};

export default Signup;
